const TOKEN_KEY = 'meal_admin_token'
const USER_KEY = 'meal_admin_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}
export function getUser() {
  return JSON.parse(localStorage.getItem(USER_KEY) || '{}')
}
export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}
export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}
export function isSuper() {
  return getUser().role === 'SUPER'
}
